import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';

export interface ChangeOwnPasswordInput {
  current_password: string;
  new_password: string;
}

/** `POST /api/me/password`: the signed-in user changes their own password. */
export const changeOwnPassword = async (body: ChangeOwnPasswordInput): Promise<void> => {
  await apiClient.post<ApiSuccess<null>>('/me/password', body);
};
